import { render, staticRenderFns } from "./AddAddress.vue?vue&type=template&id=35494d45&"
import script from "./AddAddress.vue?vue&type=script&lang=js&"
export * from "./AddAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports